<div *ngIf="quoteTaxOptions" >
  <mat-dialog-content>
    <div class="text-center">
      <div mat-dialog-title i18n>TAX CALCULATOR</div>
      <div class="mb-2">
        <span class="col-xs-12" i18n>Make the necessary changes on the form below then click Submit</span>
      </div>
    </div>
    <div class="form-group form-inline">
      <div class="col-md-9 col-xsm-12 ">Enter a % Rate for a category and click 'Calculate' to get the total tax or manually enter a total tax amount for the category</div>
      <div class="float-right">
        <img (click)="calcTaxTotals(quoteTaxOptions)" src="assets/img/circle_images/quotes_circle.png" alt="Calculate Icon" /><br />
        <div i18n>Calculate</div>
      </div>
    </div>

    <div class="row">
      <form #form="ngForm" (ngSubmit)="save(form)">
        <div *ngIf="!isMobile">
        <div class="form-group form-inline">
          <label class="col-md-2 col-sm-12" for="materialTax_Rate" i18n>Material</label>
          <input id="materialTax_Rate" name="materialTax_Rate" placeholder="% Rate" class="col-md-2 col-sm-5 form-control " [(ngModel)]="this.quoteTaxOptions.materialTax_Rate"
                 [class.field-error]="form.submitted && quoteTaxOptions.materialTax_Rate">
          <span class="col-md-1"></span>
          <input id="materialTax_Total" name="materialTax_Total" placeholder="Total" class="col-md-2 col-sm-6 form-control" [(ngModel)]="this.quoteTaxOptions.materialTax_Total"
                 (change)="materialTotalChanged()">
        </div>
        <div class="form-group form-inline">
          <label for="laborTax_Rate" class="col-md-2" i18n>Labor</label>
          <input id="laborTax_Rate" name="laborTax_Rate" placeholder="% Rate" class="col-md-2 form-control" [(ngModel)]="quoteTaxOptions.laborTax_Rate"
                 [class.field-error]="form.submitted && quoteTaxOptions.labor_Rate">
          <span class="col-md-1"></span>
          <input id="laborTax_Total" name="laborTax_Total" placeholder="Total" class="col-md-2 form-control" [(ngModel)]="quoteTaxOptions.laborTax_Total"
                 (change)="laborTotalChanged()">
        </div>
        <div class="form-group form-inline">
          <label for="otherTax_Rate" class="col-md-2" i18n>Other</label>
          <input id="otherTax_Rate" name="otherTax_Rate" placeholder="% Rate" class="col-md-2 form-control" [(ngModel)]="quoteTaxOptions.otherTax_Rate"
                 [class.field-error]="form.submitted && quoteTaxOptions.otherTax_Total">
          <span class="col-md-1"></span>
          <input id="otherTax_Total" name="otherTax_Total" placeholder="Total" class="col-md-2 form-control" [(ngModel)]="quoteTaxOptions.otherTax_Total"
                 (change)="otherTotalChanged()"
                 [class.field-error]="form.submitted && quoteTaxOptions.otherTax_Total">
        </div>

        <div class="form-group form-inline">
          <div class="form-group form-inline bg-light-blue col-md-10 col-sm-12">
            <span for="net_Total" class="col-md-3 m-3" i18n>NET TAX</span>
            <span for="net_Total" class="col-md-4 p-2" i18n></span>
            <span class="rounded float-right bg-white col-4 float-right p-2">{{this.quoteTaxOptions.netTax_Total}}</span>
          </div>
          <div class="col"></div>
        </div>
        </div>
        <div *ngIf="isMobile">

            <div class="form-group form-inline">
              <label class="col-12" i18n>Material</label>
              <input id="materialTax_Rate" name="materialTax_Rate" placeholder="% Rate" class="col-12 col-md-6 form-control" [(ngModel)]="quoteTaxOptions.materialTax_Rate"
                     [class.field-error]="form.submitted && quoteTaxOptions.materialTax_Rate">
              <input id="materialTax_Total" name="material_Total" placeholder="Total" class="col-12 col-md-6 form-control" [(ngModel)]="quoteTaxOptions.materialTax_Total"
                     (change)="materialTotalChanged()"
                     [class.field-error]="form.submitted && quoteTaxOptions.materialTax_Total">
            </div>
            <div class="form-group form-inline">
              <label for="laborTax_Rate" class="col-12" i18n>Labor</label>
              <input id="laborTax_Rate" name="laborTax_Rate" placeholder="% Rate" class="col-12 col-md-6 form-control" [(ngModel)]="quoteTaxOptions.laborTax_Rate"
                     [class.field-error]="form.submitted && quoteTaxOptions.laborTax_Rate">
              <input id="laborTax_Total" name="laborTax_Total" placeholder="Total" class="col-md-2 form-control" [(ngModel)]="quoteTaxOptions.laborTax_Total"
                     (change)="laborTotalChanged()"
                     [class.field-error]="form.submitted && quoteTaxOptions.laborTax_Total">
            </div>
            <div class="form-group form-inline">
              <label for="otherTax_Rate" class="col-12" i18n>Other</label>
              <input id="otherTax_Rate" name="other_Rate" placeholder="% Rate" class="col-12 col-md-6 form-control" [(ngModel)]="quoteTaxOptions.otherTax_Rate"
                     [class.field-error]="form.submitted && quoteTaxOptions.otherTax_Total">
              <input id="otherTax_Total" name="otherTax_Total" placeholder="Total" class="col-12 col-md-6 form-control" [(ngModel)]="quoteTaxOptions.otherTax_Total"
                     (change)="otherTotalChanged()"
                     [class.field-error]="form.submitted && quoteTaxOptions.otherTax_Total">
            </div>
            <div class="form-group form-inline bg-light-blue">
              <label for="netTax_Total" class="col-12" i18n>NET TAX</label>
              <span class="col-md-6 col-12 p-2 rounded">{{this.quoteTaxOptions.netTax_Total}}</span>
            </div>

        </div>

        <mat-dialog-actions  class="mb-1 float-end">
          <button type="submit" value="submit" name="submit" id="submit" [disabled]="isRequesting" class="btn btn-bidit-submit btn-md mr-3" i18n>Submit</button>
          <a (click)="cancelEdit()" class="btn btn-bidit-cancel btn-md" i18n>Cancel</a>
        </mat-dialog-actions>
        <app-spinner [isRunning]="isRequesting"></app-spinner>

        <div [hidden]="!form.submitted || form.valid"
             class="alert alert-danger" i18n>Validation issues encountered.  Please review your entered information.</div>
      </form>
    </div>
  </mat-dialog-content>

</div>

